module.exports = __webpack_public_path__ + "img/7.1c94313d.png";